import React, { useEffect, useState, useContext } from 'react';
import { UnreviewedItem } from './UnreviewedItem';
import { ReviewContext } from '../../Context/ReviewContext';
import { ReviewContainerContext } from './ReviewContainerContext';
import defaults from '../../../../translations/en.json';

export const ReviewContainer = (props) => {
  const {
    workflow,
    observation,
    theme,
    patientNumber,
    patientId,
    reviewsMapKey,
    siteId,
    firstName,
    lastName,
    userCredentials,
    hospiceBin,
  } = props;

  const { patientReviewsMap } = useContext(ReviewContext);
  const reviewsForRow = patientReviewsMap?.[reviewsMapKey] || [];
  const [currentPatientReviewsList, setCurrentPatientReviewsList] = useState(
    reviewsForRow,
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const [currentReview, setCurrentReview] = useState(reviewsForRow[0] || null);

  const stepReview = (n) => {
    setCurrentIndex(currentIndex + n);
  };

  const handleSubmit = () => {
    setCurrentPatientReviewsList(
      currentPatientReviewsList.filter(
        (_element, index) => index !== currentIndex,
      ),
    );
  };

  useEffect(() => {
    const newReview = { ...currentPatientReviewsList[currentIndex] };
    setCurrentReview(newReview);
    if (currentIndex >= currentPatientReviewsList.length) {
      setCurrentIndex(currentPatientReviewsList.length - 1);
    }
  }, [currentIndex, currentPatientReviewsList]);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '1vh',
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <ReviewContainerContext.Provider
        value={{
          index: currentIndex,
          dto: currentReview,
          length: currentPatientReviewsList.length,
          onSubmit: handleSubmit,
          onNext: () => stepReview(1),
          onPrev: () => stepReview(-1),
          showNext:
            currentPatientReviewsList.length !== 1 &&
            currentIndex < currentPatientReviewsList.length - 1,
          showPrev: currentPatientReviewsList.length !== 1 && currentIndex > 0,
        }}
      >
        {currentReview && currentReview.entitytypeshortname ? (
          <UnreviewedItem
            workflow={workflow}
            observation={observation}
            theme={theme}
            approvalDTO={currentReview}
            siteId={siteId}
            firstName={firstName}
            lastName={lastName}
            userCredentials={userCredentials}
            hospiceBin={hospiceBin}
            patientNumber={patientNumber}
            patientId={patientId}
          />
        ) : (
          <p>{defaults.noReviews}</p>
        )}
      </ReviewContainerContext.Provider>
    </div>
  );
};
